module.exports = __webpack_public_path__ + "img/logo.3cf09415.png";